/**
 * MODULE: _shared/lib/frontend/api/goldenCrmQuerySync.ts
 * PURPOSE: Invalidate TanStack Query caches for golden CRM dashboard hooks after shell CRM writes
 * PUBLIC_API: GOLDEN_CRM_OPPORTUNITIES_QUERY_KEY, GOLDEN_CRM_KPIS_QUERY_KEY, invalidateGoldenCrmQueries
 * AGENT_SAFETY: SAFE
 * RECENT: 2026-06-04 [2.2.1273] — TanStack keys for dashboard golden CRM; invalidate after shell CRM deal mutations. Vite re-export: **_shared/frontend/lib/frontend/api/goldenCrmQuerySync.ts**.
 */

import type { QueryClient } from '@tanstack/react-query';

export const GOLDEN_CRM_OPPORTUNITIES_QUERY_KEY = ['golden-crm-opportunities'] as const;
export const GOLDEN_CRM_KPIS_QUERY_KEY = ['golden-crm-kpis'] as const;

/** Refresh dashboard cards and global search that read GET /api/v1/crm/deals and /crm/kpis. */
export function invalidateGoldenCrmQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: [...GOLDEN_CRM_OPPORTUNITIES_QUERY_KEY] });
  void queryClient.invalidateQueries({ queryKey: [...GOLDEN_CRM_KPIS_QUERY_KEY] });
}
